// Todo move Scrapbook models here

export enum ScrapbookContentType {
  AnalyticsBuilder = 'application/x.stylus.analytics.builder+json',
  AnalyticsBuilderSection = 'application/x.stylus.analytics.builder.section+json',
  AIChat = 'application/x.stylus.sytlus-ai+json',
  AISummary = 'application/x.stylus.sytlus-ai-summary+json',
  Article = 'application/x.stylus.lnk.article+json',
  ArticleExtract = 'application/x.stylus.article.extract+json',
  Blob = 'blob',
  Colour = 'application/x.stylus.colour.chip+json',
  ColourPalette = 'application/x.stylus.colour.palette+json',
  File = 'text/plain',
  Image = 'application/x.stylus.lnk.img+json',
  Nova = 'application/x.stylus.nova+json',
  Quote = 'application/x.stylus.quote+json',
  Stat = 'application/x.stylus.stat+json',
  TechLaunchDatabase = 'application/x.stylus.tech.launch.database+json',
}

export type ScrapbookSaveItem = {
  path: string;
  contentType: string;
  content: string;
};
